@if (pwaService.showInstallPrompt() && !pwaService.isStandalone()) {
  <div class="pwa-prompt-container" role="region" aria-label="Instalação do Aplicativo">
    <div class="prompt-card">
      <div class="prompt-header">
        <div class="brand-avatar">
          <lucide-icon [img]="Sparkles" size="20"></lucide-icon>
        </div>
        <div class="prompt-text">
          <div class="badge-tag">Aplicativo Oficial</div>
          <h3 class="prompt-title">Instalar Eclesys Cerimonial</h3>
          <p class="prompt-desc">
            @if (pwaService.platform() === 'ios') {
              Instale na sua tela inicial para acesso instantâneo e experiência sem barras de navegador.
            } @else {
              Acesse mais rápido, use em tela cheia e tenha mais estabilidade durante os eventos.
            }
          </p>
        </div>
        <button type="button" class="btn-close" (click)="dismiss()" aria-label="Fechar e lembrar mais tarde">
          <lucide-icon [img]="X" size="18"></lucide-icon>
        </button>
      </div>

      <div class="prompt-actions">
        <button type="button" class="btn-dismiss" (click)="dismiss()">
          Agora não
        </button>
        <button type="button" class="btn-install" (click)="install()">
          <lucide-icon [img]="Download" size="18"></lucide-icon>
          <span>Instalar Agora</span>
        </button>
      </div>
    </div>
  </div>
}
